// Define our own enum since v6 doesn't export this directly
export enum CognitoHostedUIIdentityProvider {
  Google = 'Google',
  Facebook = 'Facebook',
  Amazon = 'Amazon',
  Apple = 'Apple'
}
